import React from "react";
import LinearGradient from "react-native-linear-gradient";
import { webOverlayStyle } from "web/constants";

export default function Overlay() {
  return (
    <LinearGradient
      colors={["rgba(77, 187, 241, 0.5)", "rgba(128, 167, 254, 0.3)"]}
      start={{ x: 0, y: 0 }} // eslint-disable-line id-length
      end={{ x: 1, y: 0 }} // eslint-disable-line id-length
      style={webOverlayStyle.overlay}
    />
  );
}
